import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import { ClearIcon, Snackbar } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers/TranslationProvider';

interface Props {
  open: boolean;
  message: string;
  duration: number;
  onClose: () => void;
  onUndo: () => void;
}

export const ConfirmationSnackbar: FC<Props> = ({ open, message, duration, onClose, onUndo }) => {
  const { t } = useTranslate();

  const action = (
    <>
      <Box sx={{ position: 'relative' }}>
        <Button sx={{ textTransform: 'uppercase' }} size="small" variant="text" onClick={onUndo}>
          {t('global.undo')}
        </Button>
      </Box>
      <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
        <ClearIcon size={20} />
      </IconButton>
    </>
  );

  return <Snackbar open={open} message={message} action={action} duration={duration} onClose={onClose} />;
};
